<template>
  <v-text-field
    :value="value"
    dense
    outlined
    single-line
    hide-details
    clearable
    label="Find"
    :prepend-inner-icon="value ? '' : 'search'"
    @input="$emit('input', $event)"
  />
</template>

<script>
export default {
  props: {
    value: { type: String, default: null }
  }
}
</script>
